import { useEffect, useRef, useState } from 'react';
import { useSearchContext } from '../../../context/Search';
import { getNestedValue } from '../../../common/utils/helpers';

const useDesktopSearchLogic = () => {
  const {
    focusedInput: [focusedInput, setFocusedInput],
  } = useSearchContext();
  const inputContainerRef = useRef(null);
  const [searchBarHeight, setSearchBarHeight] = useState(0);

  /**
   * When user clicks anywhere outside the Search component, unset any focused inputs
   * @param {Object} event The event object
   * @returns {void}
   */
  const handleBlur = event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFocusedInput();
    }
  };

  /**
   * Get the height of the search bar
   */
  useEffect(() => {
    if (getNestedValue(inputContainerRef, 'current')) {
      setSearchBarHeight(inputContainerRef.current.clientHeight);
    }
  }, [inputContainerRef]);

  return { focusedInput, handleBlur, inputContainerRef, searchBarHeight };
};

export default useDesktopSearchLogic;
